// libraries
import { Typography } from '@interstate/components/Typography';

// types
import type { CompareColumnDetailProps } from '../types/compareColumnDetailProps';

// constants
import * as constants from '../../constants';

// components
import MSRP from '../../dealSummary/sections/MSRP.interstate';
import SellingPrice from '../../dealSummary/sections/SellingPrice.interstate';
import Addons from '../../dealSummary/sections/Addons.interstate';
import NetTrade from '../../dealSummary/sections/NetTrade.interstate';
import Rebates from '../../dealSummary/sections/Rebates.interstate';
import CashDown from '../../dealSummary/sections/CashDown.interstate';
import TermLength from '../../dealSummary/sections/TermLength.interstate';
import MonthlyPayment from '../../dealSummary/sections/MonthlyPayment.interstate';
import TotalAmountDue from '../../dealSummary/sections/TotalAmountDue.interstate';
import { EmptyField } from '../../dealSummary/sections/EmptyField';
import Discount from '../../dealSummary/sections/Discount.interstate';
import TotalTax from '../../dealSummary/sections/TotalTax.interstate';
import NetSellingPrice from '../../dealSummary/sections/NetSellingPrice.interstate';
import { StyledListBordered, ColumnDetailsBlock, OfferCompareCardBlock } from './CompareColumnDetail.style';
import DealerDiscounts from '../../dealSummary/sections/DealerDiscounts.interstate';
import TotalOfPayments from '../../dealSummary/sections/TotalOfPayments.interstate';

export const CompareFinanceColumnDetail = ({ deal, hasDifference, deltaList }: CompareColumnDetailProps) => {
    return (
        <ColumnDetailsBlock data-testid="compare-finance-column-detail">
            <OfferCompareCardBlock rowName="pricing">
                <Typography variant="h4">{constants.PRICE}</Typography>
                <StyledListBordered>
                    <MSRP deal={deal} />
                    <Discount deal={deal} hasDelta={deltaList.isDiscountDelta} />
                    <DealerDiscounts deal={deal} hasDelta={deltaList.isDiscountDelta} />
                    <SellingPrice deal={deal} hasDelta={deltaList.isSellingPriceDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="addons">
                <Typography variant="h4">{constants.ADD_ONS}</Typography>
                <StyledListBordered>
                    <Addons deal={deal} hasDelta={deltaList.isAddOnsDelta} />
                    <TotalTax deal={deal} hasDelta={deltaList.isTotalTaxDelta} />
                    <NetSellingPrice deal={deal} hasDelta={deltaList.isNetSellingPriceDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="finance-reductions">
                <Typography variant="h4">{constants.FINANCE_REDUCTIONS}</Typography>
                <StyledListBordered>
                    <NetTrade deal={deal} hasDelta={deltaList.isNetTradeDelta} />
                    <Rebates deal={deal} hasDelta={deltaList.isRebatesDelta} />
                    <CashDown deal={deal} hasDelta={deltaList.isCashDownDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>

            <OfferCompareCardBlock rowName="financing-terms">
                <Typography variant="h4">{constants.FINANCING_TERMS}</Typography>
                <StyledListBordered>
                    {hasDifference && <EmptyField />}
                    <TermLength deal={deal} hasDelta={deltaList.isTermDelta} />
                    <MonthlyPayment deal={deal} hasDelta={deltaList.isMonthlyPaymentDelta} />
                    <TotalAmountDue deal={deal} hasDelta={deltaList.isTotalDueDelta} />
                    <TotalOfPayments deal={deal} hasDelta={deltaList.isTotalOfPaymentsDelta} />
                </StyledListBordered>
            </OfferCompareCardBlock>
        </ColumnDetailsBlock>
    );
};
